/** @jsx jsx */
import { jsx } from "theme-ui"
import { Box } from "rebass"

export default function PageWrap({ children, ...otherProps }) {
  return (
    <Box
      sx={{
        px: ["gridGap.small", "gridGap.large"],
      }}
      {...otherProps}
    >
      {children}
    </Box>
  )
}
